import React, { useRef, useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
const useStyles = makeStyles((theme) => ({

    container: {
        margin: "45px 0 0 0",
        width: "369px",
        padding: "30px",
        borderRadius: "20px",
        background: "#fff",
        boxShadow: "3px 3px 12px #ddd",
    },
    box: {
        margin: "20px 0px 20px",
        background: "#f3f3f3",
        paddingTop: "24px",
        textAlign: "center"
    },
    title: {

        fontSize: "20px",
        fontWeight: "500"

    },
    input: {
        width: "242px",
        height: "37px",
        borderRadius: "18px",
        marginBottom: "15px",
        border: "none",
        padding: "0px 20px",
        fontSize: "16px",
        outline: "none",
        "&:focus": {
            boxShadow: "0 0 5px #9ed4ff",
            border: "0px solid #558ab7 !important"
        }
    },
    submit: {
        width: "100%",
        heigth: "51px",
        lineHeight: "51px",
        textAlign: "center",
        background: "#3ad1bf",
        border: "none",
        fontSize: "25px",
        color: "#fff",
        fontWeight: "500",
        "&:hover": {
            cursor: "pointer"
        }

    },




}))

const LoggedOut = () => {
    const history = useHistory()
    const [inputs, setInputs] = useState({
        id: "",
        pw: ""
    });
    const { id, pw } = inputs;
    const onChange = useCallback((e) => {
        history.push('/login')
        return
        const { value, name } = e.target;

        setInputs({
            ...inputs,
            [name]: value
        })

        // console.log(inputs)
    }, [inputs])

    const onSubmit = useCallback((e) => {
        e.preventDefault();
        history.push('/login')
        return;
        setInputs({
            id: "",
            pw: ""
        })
    }, [])

    const idInput = useRef();

    const style = useStyles();

    return (
        <div className={style.container}>
            <div className={style.title}>서베이를 더 편리하게 이용하세요.</div>
            <form className={style.box}>
                <input type="text" name="id" className={style.input} ref={idInput} placeholder="ID" value={id} onChange={(e) => onChange(e)} />
                <input type="password" name="pw" className={style.input} ref={idInput} placeholder="PW" value={pw} onChange={(e) => onChange(e)} />
                <button className={style.submit} onClick={(e) => onSubmit(e)}>
                    SurBay 로그인
                </button>
            </form>
            <Link to="" style={{ textDecoration: "none", color: "#000000" }}>아이디 </Link>
            <span>I</span>
            <Link to="" style={{ textDecoration: "none", color: "#000000" }}> 비밀번호</Link>
            <Link to="/agreement" style={{ textDecoration: "none", float: "right", color: "#000000" }}>회원가입</Link>
        </div>
    );
};

export default LoggedOut;